/**
 * @file 加盟員検索モーダルの検索ボタン disabled 管理
 */
'use strict'

/**
 * @classname CheckCommonMemberSearchPossibility
 * @classdesc 加盟員検索モーダルの検索ボタン disabled 管理
 */
export default class CheckCommonMemberSearchPossibility {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#modal-common-member-search .form-control')
	 * @param {instance} controller
	 */
	constructor($e, controller) {
		console.log('CheckCommonMemberSearchPossibility.constructor')
		this._$e = $e
		this._controller = controller
		this._$formControls = this._$e.closest('.modal-body').find('.form-control')
		this._$btnCommonMemberSearch = this._$e.closest('.modal-body').find('.btn-common-member-search')
		this._$e.on('change', () => this.onChange())
	}

	/**
	 * チェンジのコールバック
	 *
	 * @memberof CheckCommonMemberSearchPossibility
	 * @return {undefined}
	 */
	onChange() {
		console.log('CheckCommonMemberSearchPossibility.onChange')
		let disabled = true
		this._$formControls.each((_, element) => {
			if ($(element).val() !== '') disabled = false
		})
		this._$btnCommonMemberSearch.prop('disabled', disabled)
	}
}
